/**
 * A form error in words a visitor can act on. The browser's own network failure ("Failed to fetch",
 * "Load failed" in Safari, "NetworkError…" in Firefox) means the request never reached us.
 */
export function formError(message: string | null | undefined): string | null {
	if (!message) return null;
	if (/failed to fetch|load failed|networkerror/i.test(message))
		return 'We couldn’t reach 05 Creation. Check your connection and try again.';
	return message;
}
